// extracted by mini-css-extract-plugin
module.exports = {"root":"IssuesContainer_root__P_zKm","container":"IssuesContainer_container__1E4VI","salesRepCode":"IssuesContainer_salesRepCode__39gkN"};